import React, { useEffect, createElement } from 'react';
const MetaPixel = () => {
  useEffect(() => {
    // Safer implementation of Meta Pixel Code
    const initPixel = () => {
      if (window.fbq) return; // Prevent duplicate initialization
      const fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      window.fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Safely append the script to head instead of finding an existing script
      document.head.appendChild(script);
      // Initialize with your pixel ID
      fbq('init', '1290000412695840');
      // Track PageView
      fbq('track', 'PageView');
    };
    // Run initialization when component mounts
    initPixel();
  }, []);
  return <>
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-207">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1290000412695840&ev=PageView&noscript=1" alt="" data-id="element-208" />
      </noscript>
    </>;
};
export default MetaPixel;